import React from 'react';
import Link from 'gatsby-link';

const races = (props) => {
    let link = "/races/" + props.page;
    return (
        <div className="col-lg-4">
            <div className="card">
                <img src={props.image} className="card-img-top"/>
                <div className="card-content">
                    <h3 className="card-title">{props.raceName}</h3>
                    <p className="card-text">{props.children}</p>
                    <div className="card-btn">
                        <Link to={link} className="btn btn-primary">View Details &raquo;</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default races;


// WEBPACK FOOTER //
// ./src/components/races.js